import {useMemo} from 'react';
import i18nService from '../i18n-service';

const useTranslation = () => {
  return useMemo(() => ({
    t: (...args) => i18nService.t(...args),
  }), []);
};

export {useTranslation};
